<div class="acs-page">

  <!-- Loading State -->
  <div *ngIf="isLoading" class="acs-page__loading">
    <acs-loading-spinner size="large" message="Loading chapters data..."></acs-loading-spinner>
  </div>

  <!-- Error State -->
  <acs-alert 
    *ngIf="error" 
    type="error" 
    title="Error Loading Chapters"
    [message]="error" 
    [dismissible]="true"
    (dismissed)="error = null">
  </acs-alert>

  <!-- Main Content -->
  <div *ngIf="!isLoading" class="acs-page__content">
    
    <!-- Header Section -->
    <div class="acs-page-header">
      <div class="acs-page-header__title-section">
        <h1 class="acs-page-header__title">Chapter Dues</h1>
        <p class="acs-page-header__subtitle">
          Comprehensive view and management of all chapters in your organization. 
          <span class="acs-page-header__role">Current user: {{ currentUser.FirstLast || 'User' }} ({{ userRole }})</span>
        </p>
      </div>
    </div>

    <!-- <acs-summary 
      [summaryCards]="summaryCards"
      [gridColumns]="4"
      cardSize="medium"
      spacing="normal" /> -->

    <!-- Chapter Data Grid Section -->
    <div class="acs-grid-section">
      <div class="acs-grid-section__header">
        <h2 class="acs-grid-section__title">Chapter Directory</h2>
        <p class="acs-grid-section__description">
          Complete directory of all chapters with detailed information and management capabilities.
          Select multiple chapters to perform bulk operations.
        </p>
      </div>

      <div class="acs-grid-section__container">
        <acs-data-grid
          [serverSide]="true"
          #duesGrid
          [entityName]="entityName"
          entityAdapter="chapters"
          [columns]="gridColumns"
          [pageSize]="50"
          [currentPage]="1"
          [showPagination]="true"
          [showPageSizeSelector]="true"
          [pageSizeOptions]="[25, 50, 100, 250]"
          [sortable]="true"
          [filterable]="true"
          [enableDropdownFilters]="true"
          [searchable]="true"
          searchPlaceholder="Search chapters by name, code, region, city, or state..."
          [selectable]="'none'"
          [exportable]="true"
          [exportFilenamePrefix]="'all-chapters-directory'"
          [stickyHeader]="true"
          [autoLoad]="true"
          emptyText="No chapters found"
          (serverError)="onServerDataError($event)">
        </acs-data-grid>
      </div>
    </div>
  </div>
</div>